/**
 * 创建get方式的url参数
 * @param {*} params 
 */
export function createGetUrlParams(params){
    let count = 0
    let result ={
        data:'',
        success:false
    }
    for (const key in params) {
      console.log(key,params[key]);
        if (params.hasOwnProperty(key)) {
            const element = params[key];
            if (!element) {
                continue
            }
            if(count == 0){
                result.data = `?${key}=${element}`
            }else{
                result.data += `&${key}=${element}`
            }
            result.success = true
            count++
        }
    }
    return result
}


// WEBPACK FOOTER //
// ./src/utils/url.js